import type { KAPLAYCtxT, /*GameObj*/ } from 'kaplay'
// import { getTiledSize } from '../utils.ts'

export function useGameUiTextFrame(_k: KAPLAYCtxT) {
  // const maxTextWidth = getTiledSize(10)
  // let objUiFrame: GameObj
  // let objUiFrameText: GameObj
  // let frameText: string | undefined = undefined

  function showTextFrame(_text?: string) {
    /*
    if (text && !frameText) {
      frameText = text

      let textComp = k.text(frameText, {
        size: 12,
        font: 'Jersey10',
        lineSpacing: -2,
      })

      if (textComp.renderArea().width > maxTextWidth) {
        textComp = k.text(frameText, {
          size: 12,
          width: maxTextWidth,
          font: 'Jersey10',
          lineSpacing: -2,
        })
      }

      const { width, height } = textComp.renderArea()

      objUiFrame = k.add([
        k.sprite('uiFrame', {
          width: width + getTiledSize(2.2),
          height: height + getTiledSize(2),
        }),
        k.pos(getTiledSize(-0.5), getTiledSize(-0.5)),
        k.fixed(),
        k.layer('ui'),
        'ui_frame',
        'ui',
      ])

      objUiFrameText = k.add([
        textComp,
        k.pos(getTiledSize(0.6), getTiledSize(0.5)),
        k.color(k.Color.fromHex('#444444')),
        k.fixed(),
        k.layer('ui'),
        'ui_frame_text',
        'ui',
      ])
    } else if (!text) {
      frameText = undefined
      try {
        k.destroy(objUiFrame)
        k.destroy(objUiFrameText)
      } catch (_err) {}
    }
     */
  }

  return {
    showTextFrame,
  }
}
